import React from "react";
import ContactForm from "./ContactForm";
import './ContactForm.module.css';

function Contact() {
    return (
        <div className="content contact-page">
            <ContactForm />
        </div>
    );
}

export default Contact;